import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { observable, computed } from 'mobx';
import { observer } from 'mobx-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { DialogService } from "src/core/services/ui/dialog.service";
import { ControllerProps } from 'src/router';
import { ObjectUtils } from 'src/core/utils/object';
import { ConfigurationService } from 'src/core/services/configuration.service';
import { EmailDocumentService } from 'src/app/general/email-document-template/email-document.service';
import { EmailTemplatePreviewView } from "./email-template-preview.view";
import { EmailDocumentTemplateListDataService } from 'src/app/general/email-document-template/list/email-document-template-list.data';
import { DropdownView } from 'src/core/ui/dropdown.view';

interface EmailTemplateEditorParams {
	model: any;
	required?: boolean;
	mode: ControlMode;
	onChanged: (data: IEmailDocumentTemplateSummary) => void;
}

export class EmailTemplateEditor extends React.Component<EmailTemplateEditorParams, any> {


	dataService: EmailDocumentTemplateListDataService;

	constructor(props) {
		super(props);

		this.dataService = EmailDocumentTemplateListDataService.make();
	}
	
	
	@autobind
	protected docTemplateQuery(q?: string): Promise<QueryResult<IEmailDocumentTemplateSummary>> {
		return new Promise<QueryResult<IEmailDocumentTemplateSummary>>((resolve, reject) => {
			this.dataService.addSorting('id', 'asc', true);
			this.dataService.searchKeywords = q;
			this.dataService.load(query => query)
				.then(res => {
					resolve({
						items: res,
						totalCount: this.dataService.count
					});
				});
		});
	}

	
	render() {
		
		return (<DropdownView
					label= {''}
					model = { this.props.model }
					required = { this.props.required }
					disabled = { this.props.mode == 'display' }
					onChanged={(newValue: any) => {
						this.props.onChanged(newValue);
						}
					}
					request={{ query: this.docTemplateQuery, dataSet: this.dataService } as any}
					keyField='id'
					textField ='name'
					/>)
		;
	}
}



// WEBPACK FOOTER //
// ./src/app/general/email-document-template/parts/email-templates.editor.tsx